import FaqAccordion from '@/components/base/FaqAccordion';
import { faqs } from '@/mocks/site';

const faqJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((item) => ({
    '@type': 'Question',
    name: item.question,
    acceptedAnswer: { '@type': 'Answer', text: item.answer },
  })),
};

export default function FaqSection() {
  return (
    <section className="w-full bg-background-50">
      <div className="mx-auto grid max-w-content grid-cols-1 gap-10 px-4 py-14 md:px-8 md:py-20 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16">
        <div className="lg:sticky lg:top-28 lg:self-start">
          <p className="mb-2 flex items-center gap-2 text-xs font-medium tracking-[0.3em] text-primary-700">
            <span className="inline-block h-px w-6 bg-primary-500"></span>
            常见问题
          </p>
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            关于档案中心，你可能想先弄清楚的几件事
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            内容的边界、来源和更正方式，都写在下面。如果还有疑问，欢迎直接来信询问，我们会把常见问题补充到这里。
          </p>
          <div className="mt-6 flex items-start gap-3 rounded-lg border border-background-200 bg-background-100 p-4">
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
              <i className="ri-shield-check-line text-lg" aria-hidden="true"></i>
            </span>
            <p className="text-xs leading-relaxed text-foreground-600">
              档案中心不收录与公共事务无关的个人隐私，也不发布未经核对的私人信息。
            </p>
          </div>
        </div>

        <FaqAccordion items={faqs} />
      </div>

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }} />
    </section>
  );
}